import { _BasketAddMinimumBuyParams, _BasketAddMinimumBuy } from 'autogen/swagger/all';
import serverSideTracking from 'components/shared/productItem/shared/helpers';
import mediator from 'modules/mediator';
import DefaultLayout from 'modules/modal/layouts/defaultLayout';
import { GA4Tracking, addToCartTypeEventCategoryMapper } from 'modules/tracking/GA4';
import createActionTracking from '../../shared/helpers';
import { ProductActionProps } from '../../shared/types';

export async function openMinimumBuyConfirmModal(params: Omit<_BasketAddMinimumBuyParams, 'isQuickSearchContext'>) {
    try {
        const [html, { default: htmlModal }] = await Promise.all([
            _BasketAddMinimumBuy({ ...params, isQuickSearchContext: false }),
            import(/* webpackChunkName: "htmlModal" */ 'modules/modal/htmlModal')
        ]);

        const modal = htmlModal({
            layout: { component: <DefaultLayout className="ui-modal--sticky-buttom" /> }
        });

        await modal({ open: true, html });
    } catch (error) {
        console.error(error);
    }
}

export default async function addMinimumQuantityProduct({ params, trackingInfo }: ProductActionProps['BuyMinimumNow']) {
    mediator.publish('closeModal');
    await openMinimumBuyConfirmModal(params);

    const GA4TrackingObject = addToCartTypeEventCategoryMapper(trackingInfo.eventCategory);

    if (params.minimumSalesQuantity) {
        GA4TrackingObject.eventParams?.push(
            {
                param_name: 'add_to_cart_quantity',
                param_value: params.minimumSalesQuantity
            },
            { param_name: 'is_minimum_quantity', param_value: true }
        );
    }

    GA4Tracking(GA4TrackingObject);

    createActionTracking(trackingInfo, { eventCategory: 'none', eventAction: 'buyBundleNow' });

    if (trackingInfo.serverSideTrackingModel) {
        serverSideTracking(trackingInfo.serverSideTrackingModel.data, trackingInfo.serverSideTrackingModel.eventType);
    }
}
